import { render, staticRenderFns } from "./couponInfo.vue?vue&type=template&id=76bafcac&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./couponInfo.vue?vue&type=style&index=0&id=76bafcac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bafcac",
  null
  
)

export default component.exports